import { Sparkles } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { ListingImportBlueprint } from '@/components/deals/ListingImportBlueprint'

export function ListingImportLock({ listingImport, hasPollingError = false, onOpenOverview }) {
  const activityLabel = listingImport?.status === 'queued'
    ? 'Preparing source listing…'
    : 'Reading source listing…'

  return (
    <section
      className="mx-auto flex min-h-[28rem] w-full max-w-3xl items-center justify-center rounded-xl border border-border bg-card p-6 shadow-sm"
      role="status"
      aria-live="polite"
    >
      <div className="flex max-w-md flex-col items-center text-center">
        <Badge variant="secondary" className="mb-5 uppercase tracking-widest">
          <Sparkles /> Blueprint Import
        </Badge>

        <ListingImportBlueprint activityLabel={activityLabel} />
        <span className="mt-2 text-xs font-semibold uppercase tracking-widest text-primary">
          Building property profile
        </span>
        <h2 className="mt-2 text-xl font-bold text-foreground">Importing listing…</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Turning source data into your Sentinel deal
        </p>
        <p className="mt-2 text-xs text-muted-foreground">Enrichment unlocks when import finishes.</p>

        {hasPollingError ? (
          <p className="mt-4 rounded-lg border border-border bg-muted/30 p-3 text-xs text-muted-foreground">
            Progress is taking longer to refresh. Sentinel will keep checking.
          </p>
        ) : null}

        <Button type="button" variant="outline" className="mt-6" onClick={onOpenOverview}>
          Open Overview
        </Button>
      </div>
    </section>
  )
}
